import { Injectable } from '@angular/core';

@Injectable({
 providedIn: 'root'
})
export class StateService {
 _stateLeilao;
 _stateOfertas;
 _stateRotas;

 get stateLeilao() {
  return this._stateLeilao;
 }

 set stateLeilao(data) {
  this._stateLeilao = data
 }

 get stateOfertas() {
  return this._stateOfertas;
 }

 set stateOfertas(data) {
  this._stateOfertas = data
 }

 get stateRotas() {
  return this._stateRotas;
 }

 set stateRotas(data) {
  this._stateRotas = data
 }

 // Zera o estado de navegacao (paginacao/filtros) das listas. Como o service e
 // um singleton em memoria, esse estado sobrevive a navegacao SPA; no login
 // precisamos zerar para uma sessao nova nao herdar filtros/paginacao da
 // anterior (antes, o reload do login fazia isso de graca).
 clear() {
  this._stateLeilao = undefined;
  this._stateOfertas = undefined;
  this._stateRotas = undefined;
 }
}